import React from 'react';

import * as styles from './TextInput.module.scss';

interface props {
    [key: string]: any
}

const TextInput = ({ ...rest }: props): JSX.Element => {
    return (
        <input className={`note ${styles.TextInput}`} type="text" {...rest} />
    );
};

export default TextInput;
